<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left">
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons" />
      </div>
    </div>
    <div class="scrollbar-container content">
      <div class="full">
        <div class="mainheader">
            {{ $t('employee.insure.ogkOverview') }}
        </div>
      </div>

      <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i> {{ ' ' + $t('employee.collective.pleaseWait') }}<br/>
        <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
        ></div>
      </div>

      <div v-show="!loading">
        <table class="styled-table">
          <thead>
            <tr>
              <th scope="col">{{ $t('global.ui.employee') }}</th>
                <th class="center" scope="col">
                    {{ $t('employee.insure.registeredSince') }}
                </th>
                <th class="center" scope="col">
                    {{ $t('employee.insure.registeredViaElda') }}
                </th>
                <th class="center" scope="col">
                    {{ $t('employee.insure.registeredUntil') }}
                </th>
                <th class="center" scope="col">
                    {{ $t('employee.insure.deregisteredViaElda') }}
                </th>
                <th class="center" scope="col">
                    {{ $t('employee.insure.contractUntil') }}
                </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entry in computedListEntries" :key="'employeeSirRow_'+entry.id" style="line-height: 36px">
              <td><i class="fas fa-arrow-up-right-from-square" v-on:click="navigateToEmployee(entry.id);" v-tooltip="$t('global.ui.toEmployee')"/> &nbsp;&nbsp;&nbsp; {{ entry.lastName +  " " + entry.firstName }}</td>
              <td class="center" v-if="entry.sir && entry.sir.registrationDate">{{ entry.sir.registrationDateFormatted }}</td>
              <td class="center" v-else-if="entry.contract" style="color: red;">{{ $t('employee.insure.noRegistration') }}</td>
              <td class="center" v-else></td>
              <td class="center">
                <i v-if="entry.sir && entry.sir.registrationDate && entry.sir.eldaReg" class="fas fa-check" style="color: green;" />
                <i v-else-if="entry.sir && entry.sir.registrationDate && !entry.sir.eldaReg" class="fas fa-times" style="color: red;"/>
              </td>
              <td class="center" v-if="entry.sir && entry.sir.deregistrationDate" v-bind:style="{'color': entry.contract && (!entry.contract.to || entry.contract.toFormatted != entry.sir.deregistrationDateFormatted) ? 'red' : ''}">
                {{ entry.sir.deregistrationDateFormatted }}
              </td>
              <td class="center" v-else-if="entry.sir && entry.sir.registrationDate && entry.contract && entry.contract.to" style="color: red;">{{ $t('employee.insure.noDeregistration') }}</td>
              <td class="center" v-else></td>
              <td class="center">
                <i v-if="entry.sir && entry.sir.deregistrationDate && entry.sir.eldaDereg" class="fas fa-check" style="color: green;" />
                <i v-else-if="entry.sir && entry.sir.deregistrationDate && !entry.sir.eldaDereg" class="fas fa-times" style="color: red;" />
              </td>
              <td class="center" v-if="entry.contract && entry.contract.to" v-bind:style="{'color': entry.sir && entry.sir.deregistrationDate && entry.sir.deregistrationDateFormatted != entry.contract.toFormatted ? 'red' : ''}">{{ entry.contract.toFormatted }}</td>
              <td class="center" v-else-if="entry.contract && !entry.contract.to"></td>
              <td class="center" v-else v-bind:style="{'color': entry.sir && entry.sir.registrationDate && !entry.sir.deregistrationDate ? 'red' : ''}">{{ $t('employee.insure.noContract') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>

</template>

<script>
import VueEventBus from '../../vue-event-bus';
import {mapState, mapGetters} from 'vuex';
import Papa from "papaparse";

export default {
  components: {},
  name: 'employeeSocialInsuranceRegistrationOverview',
  data() {
    return {
      loading: true,

      socialInsuranceRegistrations: [],
      refreshEmployeeList: 0,

      filterDropdownOptions: [],

      companyData: null,
    }
  },
  created: function () {
    //console.log("CREATED");
  },
  beforeDestroy: function () {
  },
  mounted: function () {
    let view = this;
    view.LoadFilterDropdown();
    view.refresh();
  },
  computed: {
    ...mapGetters(['companyId', 'isSuperUser', 'uiDataMap', 'employeeArray', 'employeeContractArray']),
    dateDisplay: function () {
      return this.$helpers.getMomentTZ().format('YYYY-MM-DD');
    },
    headerButtons() {
      let view = this;
      let state = {
        buttons: [
          // BUTTONS WHILE NO JOB IS SELECTED
          {
            type: "block border-r",
            icon: "fa-refresh",
            click: () => {
              view.refresh(true);
            },
            tooltip: view.$t('settings.notes.reloadData')
          },
        ],
        helperLinks: [
          {
              title: this.$t('employee.insure.getSupport'),
              helperText: this.$t('employee.insure.getSupportHelp'),
              externalUrl:
                "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
            externalLabel:  view.$t('settings.sync.contactSupport') ,
            cancelLabel: view.$t('global.ui.close'),
          }
        ]
      };
      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
      state.buttons.push({
        type: "block",
        icon: "fa-eye",
        tooltip: view.$t('comp.ui.displayFilter'),
        click: ($event) => {
          view.OpenFilterDropdown($event);
        },
      });
      return state;
    },
    computedListEntries() {
      let view = this;
      let currentDate = view.$helpers.getMomentTZ().format('YYYY-MM-DD');
      view.refreshEmployeeList; // trigger recompute after all data is loaded

      let list = view.employeeArray.sort((a, b) => {
        if (a.lastName === b.lastName) {
          return a.firstName.localeCompare(b.firstName);
        }
        return a.lastName.localeCompare(b.lastName);
      }).filter((emp) => !(emp.isHidden && view.filterDropdownOptions.find(o => o.key === "hide_hidden_employees" && o.toggled)))
      .filter((emp) => !(!(emp.sir || emp.contract) && view.filterDropdownOptions.find(o => o.key === "hide_irrelevant_employees" && o.toggled)))
      .filter((emp) => !(!(emp.sir && emp.sir.registrationDate && (!emp.sir.deregistrationDate || emp.sir.deregistrationDate >= currentDate)) && view.filterDropdownOptions.find(o => o.key === "show_only_registered_employees" && o.toggled)))

      return list;
    },
    filterDropDownOptionsWithLabels() {
      let view = this;
      return view.filterDropdownOptions.map(option => {
        return { label: view.$t(`employee.insure.${option.key}`), key: option.key, toggled: option.toggled, color: option.color, isHeader: option.isHeader };
      });
    }
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
    filterDropdownOptions: {
      handler (val, oldVal) {
        this.setFilterDropdownOptionsInStorage(val);
      },
      deep: true
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      console.log("REFRESH");
      let view = this;

      view.loading = true;

      view.socialInsuranceRegistrations = [];

      let promises = [];
      promises.push(view.$helpers.GetEmployeeMap());
      promises.push(view.$helpers.GetEmployeeContractMap());
      promises.push(view.getEmployeeSocialInsuranceRegistrations());

      Promise.all(promises)
        .then((responses) => {
          view.loading = false;
          console.log(view.employeeArray);
          console.log(view.employeeContractArray);
          console.log(view.socialInsuranceRegistrations);

          view.employeeArray.forEach(emp => {
            emp.sir = view.socialInsuranceRegistrations.find(reg => reg.employeeId === emp.id) || null;
            if (emp.sir) {
              emp.sir.registrationDateFormatted = emp.sir.registrationDate ? view.$helpers.getMomentFromString(emp.sir.registrationDate, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
              emp.sir.deregistrationDateFormatted = emp.sir.deregistrationDate ? view.$helpers.getMomentFromString(emp.sir.deregistrationDate, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
            }
            emp.contract = view.employeeContractArray.filter(contract => contract.remoteId === emp.id).reduce((latest, contract) => {
              if (!latest || new Date(contract.from) > new Date(latest.from)) {
                return contract;
              }
              return latest;
            }, null);
            if (emp.contract) {
              emp.contract.fromFormatted = emp.contract.from ? view.$helpers.getMomentFromString(emp.contract.from, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
              emp.contract.toFormatted = emp.contract.to ? view.$helpers.getMomentFromString(emp.contract.to, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
            }
          });
          view.refreshEmployeeList++;
        });

    },

    getEmployeeSocialInsuranceRegistrations: function(page = 1){
        let view = this;
        let url = '/api/sec/employee/socialinsuranceregistration/latest';

        url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, '/api/sec/employee/socialinsuranceregistration/latest');

        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "Bearer "+this.$store.state.jwt
            },
            url: url
        }).then(response => {
          if (page == 1) {
            view.socialInsuranceRegistrations = [];
          }
          view.socialInsuranceRegistrations = view.socialInsuranceRegistrations.concat(response.data.data);
          // console.log(response);
          if (response.data.current_page < response.data.last_page) {
            return view.getEmployeeSocialInsuranceRegistrations(page + 1);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    OpenFilterDropdown($event) {
      var view = this;
      var target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: "list",
        componentState: {
          entries: view.filterDropDownOptionsWithLabels,
        },
        remainAfterSelect: true,
        pointerDirection: 0,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;
        },
      });
    },
    LoadFilterDropdown() {
      var view = this;
      this.filterDropdownOptions = view.getFilterDropdownOptionsFromStorage();
      if (this.filterDropdownOptions.length === 0) {
        view.filterDropdownOptions.push({
          key: "employeelist_header",
          toggled: true,
          color: "var(--ml)",
          isHeader: true
        });
        view.filterDropdownOptions.push({
          key: "hide_hidden_employees",
          toggled: true,
          color: "var(--ml)",
          isHeader: false
        });
        view.filterDropdownOptions.push({
          key: "hide_irrelevant_employees",
          toggled: true,
          color: "var(--ml)",
          isHeader: false
        });
        view.filterDropdownOptions.push({
          key: "show_only_registered_employees",
          toggled: true,
          color: "var(--ml)",
          isHeader: false
        });
      }
    },

    getFilterDropdownOptionsFromStorage() {
      let ls = localStorage.getItem("esiro_options");
      let filterDropdownOptions = [];
      if (ls != undefined) {
        filterDropdownOptions = JSON.parse(ls);
      }
      return filterDropdownOptions;
    },
    setFilterDropdownOptionsInStorage(data) {
      localStorage.setItem("esiro_options", JSON.stringify(data));
    },

    navigateToEmployee: function (employeeId) {
      let view = this;
      //console.log(employeeId);

      view.$router.push({
        path: "../documents/employeedata",
        query: { employeeId: employeeId },
      });
      VueEventBus.$emit("changeEmployee", employeeId);
    },





  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.xColumn3 {
  width: 400px;
  text-align: left;
  float: left;
  margin-left: 25px;
  margin-right: 25px;
  overflow-y: auto;
  max-height: 800px;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

tr:hover .btn-ml {
  color: #fff;
  background-color: var(--ml-alt);
  border-color: #fff;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.buttons {
  width: 100%;
  display: flex;
  justify-content: center;
}

.emp-core-data {
  display: flex;
  align-items: center;
  padding: 5px;
}

.emp-core-data > div {
  padding-right: 5px;
}

.label-pagination{
  display: inline;
  font-family: DistrictProBook;
  font-size: 14px;
  color: var(--contrast-4);
}


</style>
